import { getAccessToken } from '../actions/GoogleDriveActions';

const API_KEY = process.env.REACT_APP_GOOGLE_DRIVE_API_KEY;
const APP_ID = process.env.REACT_APP_GOOGLE_DRIVE_APP_ID;

const google = window.google;

// https://developers.google.com/workspace/drive/picker/reference/picker.viewid
// https://developers.google.com/workspace/drive/picker/reference/picker.pickerbuilder.addview.md
function createViewGroup(views) {
  const [firstView, ...restViews] = views;
  const group = new google.picker.ViewGroup(firstView);
  restViews.forEach((v) => {
    group.addView(v);
  });
  return group;
}

// Create and render a Google Picker object for selecting from Drive.
function createPicker(accessToken, cb) {
  const showPicker = () => {
    const viewGroup = createViewGroup([
      new google.picker.DocsView(
        google.picker.ViewId.FOLDERS
      ).setSelectFolderEnabled(true),
    ]);
    const picker = new google.picker.PickerBuilder()
      .addViewGroup(viewGroup)
      .setOAuthToken(accessToken)
      .setDeveloperKey(API_KEY)
      .setCallback((data) => pickerCallback(data, cb))
      .setAppId(APP_ID)
      .build();
    picker.setVisible(true);
  };

  showPicker();
}

// A simple callback implementation.
function pickerCallback(data, cb) {
  if (data[google.picker.Response.ACTION] === google.picker.Action.PICKED) {
    const doc = data[google.picker.Response.DOCUMENTS][0];
    return cb(doc);
  }
}

export async function showPicker() {
  const { accessToken } = await getAccessToken();
  return new Promise((resolve) => {
    createPicker(accessToken, resolve);
  });
}
